import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
    width: "100%",
    height: "400px"
};
const center = {
    lat: 48.6395663, // Latitude (ex: Paris)
    lng: 4.9516143  // Longitude
};

export const Map = (props) => {
    const {data} = props.data
    return (
        data ? <LoadScript googleMapsApiKey={data.apikey}>
            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={15}>
                <Marker position={center} />
            </GoogleMap>
        </LoadScript> : <></>
    );
}